"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthClass = widthClass;
exports.getExpandableRowProps = getExpandableRowProps;
exports.processExpandableChildren = processExpandableChildren;
exports.hasExpandableRows = hasExpandableRows;
exports.hasExpandableBody = hasExpandableBody;
exports.processChildren = processChildren;
exports.scrollableHeightProp = scrollableHeightProp;
exports.propagateWidths = exports.propagateWidthsForRows = exports.propagateWidthsForCells = void 0;

var _react = _interopRequireDefault(require("react"));

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

var _data = require("./data");

var _header = require("./header");

var _ExpandableRow = _interopRequireDefault(require("./expandable/ExpandableRow"));

var _Body = _interopRequireDefault(require("./Body"));

var _consts = require("./consts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function widthClass(width) {
  return width ? "co-table--".concat(width) : null;
}

var propagateWidthsForCells = function propagateWidthsForCells(childrenProp, cellWidths) {
  var children = _react.default.Children.toArray(childrenProp);

  var newCells = children.map(function (child, index) {
    return ((0, _compareElementType.default)(child, _data.Data) || (0, _compareElementType.default)(child, _header.Header)) && !child.props.width && cellWidths[index] ? _react.default.cloneElement(child, {
      width: cellWidths[index]
    }) : child;
  });
  return newCells;
};

exports.propagateWidthsForCells = propagateWidthsForCells;

var propagateWidthsForRows = function propagateWidthsForRows(childrenProp, cellWidths) {
  var children = _react.default.Children.toArray(childrenProp);

  var newRows = children.map(function (child) {
    return _react.default.cloneElement(child, {
      children: propagateWidthsForCells(child.props.children, cellWidths)
    });
  });
  return newRows;
};

exports.propagateWidthsForRows = propagateWidthsForRows;

var propagateWidths = function propagateWidths(childrenProp) {
  var children = _react.default.Children.toArray(childrenProp);

  var firstBlockChildren = _react.default.Children.toArray(children[0].props.children);

  var cellWidths = _react.default.Children.map(_react.default.Children.toArray(firstBlockChildren[0].props.children), function (cell) {
    return cell.props.width || false;
  });

  var newBlocks = children.map(function (child) {
    return _react.default.cloneElement(child, {
      children: propagateWidthsForRows(child.props.children, cellWidths)
    });
  });
  return newBlocks;
};

exports.propagateWidths = propagateWidths;

function getExpandableRowProps(row) {
  return {
    expanded: row.props.expanded,
    colSpan: _react.default.Children.count(row.props.children) + 1 // we need to take the chevron into account

  };
}

function processExpandableChildren(childrenProp) {
  var processedChildren = _react.default.Children.map(childrenProp, function (child) {
    if ((0, _compareElementType.default)(child, _ExpandableRow.default)) {
      var _getExpandableRowProp = getExpandableRowProps(child),
          expanded = _getExpandableRowProp.expanded,
          colSpan = _getExpandableRowProp.colSpan;

      var content = child.props.content;

      var clonedRow = _react.default.cloneElement(child, {
        content: _react.default.cloneElement(content, {
          expanded: expanded,
          colSpan: colSpan
        })
      });

      return clonedRow;
    }

    return child;
  });

  return processedChildren;
}

function hasExpandableRows(body) {
  var children = body.props.children;

  var expandableRows = _react.default.Children.map(children, function (child) {
    return (0, _compareElementType.default)(child, _ExpandableRow.default) ? child : null;
  });

  return expandableRows && expandableRows.length > 0;
}

function hasExpandableBody(children) {
  var expandableBodies = _react.default.Children.map(children, function (child) {
    return (0, _compareElementType.default)(child, _Body.default) && hasExpandableRows(child) ? child : null;
  });

  return expandableBodies.length > 0;
}

function processChildren(children, _ref) {
  var scrollable = _ref.scrollable,
      scrollableHeight = _ref.scrollableHeight,
      draggable = _ref.draggable;
  var options = {
    hasExpandableRows: false
  };

  if (scrollable || scrollableHeight) {
    return {
      processedChildren: propagateWidths(children),
      options: options
    };
  }

  var processedChildren = _react.default.Children.map(children, function (child) {
    if ((0, _compareElementType.default)(child, _Body.default)) {
      if (draggable) {
        return _react.default.cloneElement(child, {
          draggable: draggable
        });
      }

      var isExpandable = hasExpandableRows(child);
      options.hasExpandableRows = isExpandable;
      return isExpandable ? processExpandableChildren(child.props.children) : child;
    } else {
      return child;
    }
  });

  return {
    processedChildren: processedChildren,
    options: options
  };
}

function scrollableHeightProp(props, propName) {
  if (props[propName]) {
    if (hasExpandableBody(props.children)) {
      return new Error('Scrollable Tables do not support expandable rows.');
    }

    if (!_consts.validScrollableValues.includes(props[propName])) {
      return new Error('Invalid scrollable value. It has to be one of: ' + _consts.validScrollableValues.toString());
    }
  }

  return null;
}